import Ajax from 'global/od/Ajax';
import BraintreeClient from './BraintreeClient';

export default class BraintreePayPalPayment extends BraintreeClient {
	constructor() {
		super();
		this.paypalCheckoutInstance = null;
		this.payPalButtonId = 'paypal-button';
		this.loadingButton = document.getElementById('loading-paypal-button');
		this.payPalButton = document.getElementById(this.payPalButtonId);
		this.init();
	}

	async init() {
		try {
			const client = await this.createClient();
			const paypalCheckout = await this.braintree.paypalCheckout.create({
				client,
			});
			this.paypalCheckoutInstance = await paypalCheckout.loadPayPalSDK({
				currency: this.currency,
			});

			paypal // eslint-disable-line no-undef
				.Buttons({
					fundingSource: paypal.FUNDING.PAYPAL, // eslint-disable-line no-undef
					createOrder: this.createOrder.bind(this),
					onInit: this.onInit.bind(this),
					onClick: this.onClick.bind(this),
					onApprove: this.onApprove.bind(this),
					onCancel: this.redirectToBillingPage,
					onError: this.onError.bind(this),
				})
				.render(`#${this.payPalButtonId}`);
		} catch (error) {
			console.error('[Braintree PayPal Checkout Instance error]:', error); // eslint-disable-line no-console
		}
	}

	async createOrder() {
		this.showLoadingButton();

		let deliveryAddress;

		try {
			const response = await Ajax.get(`/ajax/checkout/shipping-address/data`);

			if (response.status >= 200 && response.status <= 299) {
				const { data } = response;

				if (!data || !data.shippingAddress) {
					throw new Error('Empty shipping address data');
				}
				[deliveryAddress] = data.shippingAddress;
			} else {
				throw new Error(`Status: ${response.status}`);
			}
		} catch (error) {
			console.error('Failed to get shipping address:', error); // eslint-disable-line no-console
		}

		return this.paypalCheckoutInstance.createPayment({
			flow: 'checkout',
			amount: this.amount,
			currency: this.currency,
			shippingAddressOverride: {
				line1: deliveryAddress.line1,
				line2: deliveryAddress.line2,
				city: deliveryAddress.town,
				state: deliveryAddress.currentCountry,
				postalCode: deliveryAddress.postalCode,
				countryCode: deliveryAddress.countryIso,
				phone: deliveryAddress.phone,
				recipientName: deliveryAddress.contactName,
			},
		});
	}

	onInit(data, actions) {
		if (!this.termsAndConditionsCheckbox.checked) actions.disable();
		this.termsAndConditionsCheckbox.addEventListener('change', ({ target }) => {
			if (target.checked) {
				actions.enable();
			} else {
				actions.disable();
			}
		});
		this.hideLoadingButton();
	}

	onClick() {
		if (!this.termsAndConditionsCheckbox.checked) this.form.requestSubmit();
	}

	async onApprove(data) {
		const { nonce } = await this.paypalCheckoutInstance.tokenizePayment(data);
		this.submitFormWithBraintreeNonce(this.form, nonce);
	}

	onError(error) {
		this.hideLoadingButton();
		console.error('[Braintree PayPal Button error]:', error); // eslint-disable-line no-console
	}

	hideLoadingButton() {
		this.loadingButton.setAttribute('hidden', '');
		this.payPalButton.removeAttribute('hidden');
	}

	showLoadingButton() {
		this.payPalButton.setAttribute('hidden', '');
		this.loadingButton.removeAttribute('hidden');
	}
}
